<template>
  <div class="cm-title">
    <div class="background">
      <img :src="util.getImageUrl(bean.image, '1100x260')" alt />
    </div>
    <div class="left">
      <img :src="util.getImageUrl(bean.image, '200x200')" alt />
    </div>
    <div class="right">
      <div class="name">{{bean.name}}</div>
      <div class="description">{{bean.description}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommodityMarketingTitle",
  props: ["bean"]
};
</script>

<style lang="less" scoped>
.cm-title {
  width: 1100px;
  //   overflow: hidden;
  //   margin: 32px 0;

  padding: 32px 0;

  .background {
    position: absolute;
    width: 1100px;
    height: 260px;

    background: #000;
    opacity: 0.6;

    img {
      width: 100%;
      height: 100%;
      filter: blur(100px);
    }

    border-radius: 20px;
    overflow: hidden;
  }

  .left {
    display: inline-block;
    vertical-align: top;
    width: 200px;
    margin: 0 32px;
    position: relative;
    top: -32px;
    img {
      width: 200px;
      height: 200px;
      border-radius: 10px;
    }

    opacity: 0.99;
  }

  .right {
    display: inline-block;
    vertical-align: top;
    width: 800px;
    opacity: 0.99;

    .name {
      font-size: 26px;

      font-weight: bold;
      color: white;
      line-height: 37px;

      margin: 20px 0;
    }

    .description {
      color: white;
      line-height: 20px;
    }
  }
}
</style>

